import { useMemo } from 'react';
import { getSpellCheckLanguage } from '../utils/spellCheck';
import { getBrowserLocale } from '../utils/locale';

export const useProseSpellCheckLanguage = () => {
  return getSpellCheckLanguage(getBrowserLocale());
};

const useProseSpellCheckAttributes = () => {
  const language = useProseSpellCheckLanguage();

  return useMemo(
    () => ({
      lang: language,
      spellCheck: true
    }),
    [language]
  );
};

export default useProseSpellCheckAttributes;
